<template>
  <ReadyFlowsInsightHeader
    v-if="actor.snapshot.value.matches('fetchedInsights')"
    @click="actor.send({ type: 'OPEN_DRAWER' })"
  />

  <ReadyFlowsInsightDrawer
    :open="actor.snapshot.value.hasTag('drawerOpen')"
    @close="actor.send({ type: 'CLOSE_DRAWER' })"
  >
    <div class="tw:flex tw:flex-col tw:gap-6">
      <ReadyFlowsInsightDrawerSection
        :description="actor.snapshot.value.context.data!.introduction"
        :title="trans._readyFlows.smartInsight.drawer.content.summary"
      />

      <div class="tw:flex tw:flex-col tw:gap-3 tw:px-4">
        <div class="tw:flex tw:gap-2 tw:items-center tw:justify-between">
          <p class="tw:body-1--bold">{{ trans._readyFlows.smartInsight.drawer.content.observations }}</p>

          <ReadyFlowsInsightDrawerPagination
            :current-insight-index="currentInsightIndex"
            :number-of-insights="numberOfInsights"
            @change-insight-index="handleChangeActiveInsightIndex"
          />
        </div>

        <ReadyFlowsInsightSanitizedContent :content="content" />
      </div>

      <ReadyFlowsInsightDrawerSection
        :description="actor.snapshot.value.context.data!.summary"
        :title="trans._readyFlows.smartInsight.drawer.content.recommendations"
      />
    </div>
  </ReadyFlowsInsightDrawer>
</template>

<script lang="ts" setup>
import { useMachine } from "@xstate-5/vue";
import { computed, provide } from "vue";
import { inspector } from "vue-app/utils/xstate";
import { machineReadyFlowsInsight, symbolMachineReadyFlowsInsight } from "./ReadyFlowsInsight.machine";
import ReadyFlowsInsightDrawerSection from "./ReadyFlowsInsightDrawer/ReadyFlowsInsightDrawerSection.vue";
import ReadyFlowsInsightDrawer from "./ReadyFlowsInsightDrawer/ReadyFlowsInsightDrawer.vue";
import ReadyFlowsInsightHeader from "./ReadyFlowsInsightHeader.vue";
import ReadyFlowsInsightSanitizedContent from "./ReadyFlowsInsightSanitizedContent.vue";
import ReadyFlowsInsightDrawerPagination from "./ReadyFlowsInsightDrawer/ReadyFlowsInsightDrawerPagination.vue";

const actor = useMachine(machineReadyFlowsInsight, { inspect: inspector().inspect });
provide(symbolMachineReadyFlowsInsight, actor);

const currentInsightIndex = computed(() => actor?.snapshot.value.context.activeInsightIndex);
const content = computed(() => actor.snapshot.value.context.data?.insights[currentInsightIndex.value] || "");
const numberOfInsights = computed(() => actor.snapshot.value.context.data?.insights.length || 0);

const handleChangeActiveInsightIndex = (newTabIndex: number) => {
  actor.send({ type: "SET_ACTIVE_INSIGHT_INDEX", index: newTabIndex });
};
</script>
